import { render, staticRenderFns } from "./image-lightbox.vue?vue&type=template&id=bf46c908"
import script from "./image-lightbox.vue?vue&type=script&lang=js"
export * from "./image-lightbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports